import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-homethree-features',
  templateUrl: './homethree-features.component.html',
  styleUrls: ['./homethree-features.component.scss']
})
export class HomethreeFeaturesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
